import { render, staticRenderFns } from "./WorkTasks.vue?vue&type=template&id=33278e47&scoped=true"
import script from "./WorkTasks.vue?vue&type=script&lang=ts"
export * from "./WorkTasks.vue?vue&type=script&lang=ts"
import style0 from "./WorkTasks.vue?vue&type=style&index=0&id=33278e47&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33278e47",
  null
  
)

export default component.exports